import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload";
import { xlsxExport } from "../../../utils/xlsxExport";
import Table from "../../../components/table/coreUiTable/Table";
import DataDisplay from "../../../components/dataDisplay/dataDisplay";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import NoData from "../../../components/noData/noData";
import { api } from "./api";
import { useTableData } from "../hooks/useTableData";

export const WhiteListIpsModule = () => {
  let {
    loading,
    headerInfo = [],
    tableInfo: { data, colHeaders } = {}
  } = useTableData({
    endpoint: api.getList
  });

  if (loading) return <LoadingAnimation />;

  return data && data.length > 0 ? (
    <div id="white-list-ips-table">
      <div className="data-points">
        {headerInfo.map((dataPoint) => (
          <DataDisplay key={dataPoint[0]} label={dataPoint[0]} value={dataPoint[1]} />
        ))}
      </div>
      <Table
        table={{ colHeaders, data }}
        tableFilter={false}
        showCount
        sorter
        itemsPerPage={15}
        overTableSlots={
          <div className="content_download">
            {data.length > 0 ? (
              <>
                <a
                  title="Download as Excel"
                  onClick={() => {
                    xlsxExport({
                      data: data,
                      headers: colHeaders,
                      fileName: "white-list-ips"
                    });
                  }}
                >
                  <FontAwesomeIcon icon={faDownload} /> Download as Excel
                </a>
                <a
                  title="Download as CSV"
                  onClick={() => {
                    xlsxExport({
                      data: data,
                      headers: colHeaders,
                      fileName: "white-list-ips",

                      fileType: "csv"
                    });
                  }}
                >
                  <FontAwesomeIcon icon={faDownload} /> Download as CSV
                </a>
              </>
            ) : (
              <>
                <span disabled>
                  <FontAwesomeIcon icon={faDownload} /> Download as Excel
                </span>
                <span disabled>
                  <FontAwesomeIcon icon={faDownload} /> Download as CSV
                </span>
              </>
            )}
          </div>
        }
      />
    </div>
  ) : (
    <NoData />
  );
};
